import type React from "react";
import { createContext, type ReactNode, useContext, useState } from "react";

interface EstimationValidationType {
  unitPriceHasError: boolean;
  setUnitPriceHasError: (b: boolean) => void;
  complexityHasError: boolean;
  setComplexityHasError: (b: boolean) => void;
}

export const EstimationValidation = createContext<EstimationValidationType | undefined>(undefined);

export const ValidationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [unitPriceHasError, setUnitPriceHasError] = useState(false);
  const [complexityHasError, setComplexityHasError] = useState(false);
  return (
    <EstimationValidation.Provider
      value={{ unitPriceHasError, setUnitPriceHasError, complexityHasError, setComplexityHasError }}
    >
      {children}
    </EstimationValidation.Provider>
  );
};

export const useValidation = (): EstimationValidationType => {
  const ctx = useContext(EstimationValidation);
  if (!ctx) throw new Error("useValidation must be used within ValidationProvider");
  return ctx;
};
